// extracted by mini-css-extract-plugin
module.exports = {"onlineLocation":"OnlineLocation_onlineLocation__zI_1J","text":"OnlineLocation_text__Zgzaa","link":"OnlineLocation_link__cYbwr"};